module.exports = __webpack_public_path__ + "static/img/04img.cd435c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/01challengeList/04img.png
// module id = XLZD
// module chunks = 0